'use client';
import classNames from 'classnames';
import { Header } from '../components/Header/Header';
import styles from '../index.module.css';
import { Animate } from '../components/shared/Animation/Animate';
import Image from 'next/image';
import Marquee from 'react-fast-marquee';
import Testimonial from '../components/Testimonial/Testimonial';
import ContactSection from '../components/ContactSection/ContactSection';
import ScrollToTop from '@/components/ScrollToTop/ScrollToTop';
import { useRef } from 'react';
import Link from 'next/link';

// Custom social icons components
const FacebookIcon = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.socialSvgIcon}
  >
    <path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z" />
  </svg>
);

const InstagramIcon = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.socialSvgIcon}
  >
    <path d="M12 2c-2.716 0-3.056.012-4.123.06-1.064.049-1.791.218-2.427.465a4.902 4.902 0 00-1.772 1.153A4.902 4.902 0 002.525 5.45c-.247.636-.416 1.363-.465 2.427C2.012 8.944 2 9.284 2 12s.012 3.056.06 4.123c.049 1.064.218 1.791.465 2.427a4.902 4.902 0 001.153 1.772 4.902 4.902 0 001.772 1.153c.636.247 1.363.416 2.427.465 1.067.048 1.407.06 4.123.06s3.056-.012 4.123-.06c1.064-.049 1.791-.218 2.427-.465a4.902 4.902 0 001.772-1.153 4.902 4.902 0 001.153-1.772c.247-.636.416-1.363.465-2.427.048-1.067.06-1.407.06-4.123s-.012-3.056-.06-4.123c-.049-1.064-.218-1.791-.465-2.427a4.902 4.902 0 00-1.153-1.772 4.902 4.902 0 00-1.772-1.153c-.636-.247-1.363-.416-2.427-.465C15.056 2.012 14.716 2 12 2zm0 1.802c2.67 0 2.986.01 4.04.058.975.045 1.505.207 1.858.344.466.182.8.399 1.15.748.35.35.566.684.748 1.15.137.353.3.883.344 1.857.048 1.055.058 1.37.058 4.041 0 2.67-.01 2.986-.058 4.04-.045.975-.207 1.505-.344 1.858-.182.466-.399.8-.748 1.15-.35.35-.684.566-1.15.748-.353.137-.883.3-1.857.344-1.054.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.975-.045-1.505-.207-1.858-.344-.466-.182-.8-.399-1.15-.748-.35-.35-.566-.684-.748-1.15-.137-.353-.3-.883-.344-1.857-.048-1.055-.058-1.37-.058-4.041 0-2.67.01-2.986.058-4.04.045-.975.207-1.505.344-1.858.182-.466.399-.8.748-1.15.35-.35.684-.566 1.15-.748.353-.137.883-.3 1.857-.344 1.055-.048 1.37-.058 4.041-.058zm0 3.064a5.134 5.134 0 100 10.268 5.134 5.134 0 000-10.268zm0 8.466a3.332 3.332 0 110-6.664 3.332 3.332 0 010 6.664zm6.538-8.671a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0z" />
  </svg>
);

const TwitterIcon = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.socialSvgIcon}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.socialSvgIcon}
  >
    <path d="M4.98 3.5C4.98 4.881 3.87 6 2.5 6S.02 4.881.02 3.5C.02 2.12 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM5 8H0v16h5V8zm7.982 0H8.014v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0V24H24V13.869c0-7.88-8.922-7.593-11.018-3.714V8z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.socialSvgIcon}
  >
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const testimonials = [
  {
    image: '/testimonial1.webp',
    text: 'JimGym has completely transformed how I manage my gym! The all-in-one platform saves me hours of administrative work every week, and my clients love how easy it is to book classes and track their progress.',
    name: 'Sarah J.',
    age: 32,
    position: 'Gym Owner',
  },
  {
    image: '/testimonial2.webp',
    text: 'As a personal trainer, JimGym has made it effortless to manage my client schedules and track their fitness progress. The analytics features help me show my clients real results, which has increased my retention rates by 35%.',
    name: 'Mike T.',
    age: 45,
    position: 'Independent Trainer',
  },
  {
    image: '/testimonial3.webp',
    text: "I've tried several gym management platforms before, but JimGym is in a league of its own. The multi-gym management features allow me to keep tabs on all my locations from one dashboard, saving me countless hours and headaches.",
    name: 'Alex D.',
    age: 30,
    position: 'Multi-Gym Owner',
  },
];

const pricingPlans = [
  {
    name: 'Starter',
    price: '49',
    features: [
      'Single gym management',
      'Basic scheduling',
      'Member portal',
      'Payment processing',
      'Email support',
    ],
    recommended: false,
    ctaText: 'Get Started',
  },
  {
    name: 'Professional',
    price: '99',
    features: [
      'Everything in Starter',
      'Trainer management',
      'Advanced analytics',
      'Custom branding',
      'Priority support',
      'Mobile app access',
    ],
    recommended: true,
    ctaText: 'Start Free Trial',
  },
  {
    name: 'Enterprise',
    price: '249',
    features: [
      'Everything in Professional',
      'Multi-gym management',
      'API access',
      'White label option',
      'Dedicated account manager',
      'Custom integrations',
    ],
    recommended: false,
    ctaText: 'Contact Sales',
  },
];

export default function Home() {
  const scrollableDivRef = useRef<HTMLDivElement | null>(null);

  return (
    (<div className={styles.home} ref={scrollableDivRef}>
      <Header />
      {/* Hero Section */}
      <section
        className={classNames(
          styles.heroSection,
          styles.section,
          'min-h-screen'
        )}
      >
        <div className={styles.content}>
          <Animate animationName="slideUp">
            <h1>JimGym</h1>
            <p className="max-w-2xl mx-auto">
              The all-in-one SaaS platform designed to simplify gym management,
              empower trainers, and enhance member experience.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
              <Link href="/auth/signup" passHref>
                <button className="bg-gradient-to-r from-indigo-600 to-violet-500 hover:from-indigo-700 hover:to-violet-600 text-white px-8 py-3 rounded-full font-medium shadow-lg transition-all hover:shadow-indigo-500/20 text-lg">
                  Start Free Trial
                </button>
              </Link>
              <Link href="#features" passHref>
                <button className="bg-transparent border-2 border-white/30 text-white px-8 py-3 rounded-full font-medium hover:bg-white/10 transition-all text-lg">
                  Learn More
                </button>
              </Link>
            </div>
          </Animate>
        </div>
      </section>
      {/* Features Section */}
      <section
        id="features"
        className={classNames(styles.features, styles.section)}
      >
        <div className={styles.content}>
          <Animate animationName="slideLeft">
            <h1 className={styles.featuresTitle}>Powerful Features</h1>
            <p className={styles.featuresDescription}>
              Discover how JimGym helps gym owners, trainers, and members
              achieve their goals with our comprehensive solution.
            </p>
          </Animate>
          <Animate animationName="slideRight">
            <div className={styles.featuresContainer}>
              <div className={styles.feature}>
                <h2 className={styles.featureTitle}>Smart Gym Management</h2>
                <div className={styles.overlay}>
                  <p className={styles.featureDescription}>
                    Efficiently manage memberships, payments, and facilities all
                    in one place. Gain valuable insights with advanced analytics
                    and reporting.
                  </p>
                </div>
                <Image
                  height={300}
                  width={300}
                  className={styles.featureImage}
                  src="/equipment.webp"
                  alt="Gym Management Dashboard"
                />
              </div>
              <div className={styles.feature}>
                <h2 className={styles.featureTitle}>Trainer Toolbox</h2>
                <div className={styles.overlay}>
                  <p className={styles.featureDescription}>
                    Empower trainers with scheduling, client management, and
                    customizable workout plan creation tools to deliver
                    exceptional service.
                  </p>
                </div>
                <Image
                  height={300}
                  width={300}
                  className={styles.featureImage}
                  src="/workoutplans.webp"
                  alt="Trainer Dashboard"
                />
              </div>
              <div className={styles.feature}>
                <h2 className={styles.featureTitle}>Member Experience</h2>
                <Image
                  height={300}
                  width={300}
                  className={styles.featureImage}
                  src="/gymclasses.webp"
                  alt="Member App"
                />
                <div className={styles.overlay}>
                  <p className={styles.featureDescription}>
                    Give members the ability to book classes, track fitness
                    progress, and connect with trainers through an intuitive
                    mobile and web interface.
                  </p>
                </div>
              </div>
              <div className={styles.feature}>
                <h2 className={styles.featureTitle}>Multi-Gym Solution</h2>
                <Image
                  height={300}
                  width={300}
                  className={styles.featureImage}
                  src="/workoutplans.webp"
                  alt="Multi-Gym Management"
                />
                <div className={styles.overlay}>
                  <p className={styles.featureDescription}>
                    Scale your fitness empire with our enterprise solution
                    designed for managing multiple locations from a single,
                    unified dashboard.
                  </p>
                </div>
              </div>
            </div>
          </Animate>
        </div>
      </section>
      {/* Testimonials Section */}
      <section
        id="testimonials"
        className={classNames(styles.testimonials, styles.section)}
      >
        <div className={styles.content}>
          <Animate animationName="slideDown">
            <h1 className={styles.testimonialsTitle}>What Our Customers Say</h1>
            <p className={styles.testimonialsDescription}>
              Trusted by gym owners, trainers and fitness professionals
              worldwide
            </p>
          </Animate>
          <Animate animationName="slideUp">
            <Marquee
              style={{ marginTop: 15 }}
              pauseOnHover
              gradient
              gradientWidth={20}
              gradientColor="var(--myrtle-green)"
            >
              {testimonials.map((testimonial, i) => (
                <Testimonial key={i} testimonial={testimonial} />
              ))}
            </Marquee>
          </Animate>
        </div>
      </section>
      {/* Pricing Section */}
      <section
        id="pricing"
        className={classNames(
          styles.section,
          'bg-gradient-to-b from-gray-900 to-gray-950 min-h-screen flex items-center py-20'
        )}
      >
        <div className={styles.content}>
          <Animate animationName="slideUp">
            <h1 className={styles.pricingTitle}>Simple, Transparent Pricing</h1>
            <p className={styles.pricingDescription}>
              Choose the plan that best fits your business needs
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
              {pricingPlans.map((plan, index) => (
                <Animate
                  key={index}
                  animationName="scaleIn"
                  delay={`${(index + 1) * 100}` as '100' | '200' | '300'}
                  threshold={0.1}
                >
                  <div
                    className={classNames(
                      'group relative bg-gray-800/50 backdrop-blur-sm rounded-2xl overflow-hidden border transition-all duration-500 h-full flex flex-col',
                      plan.recommended
                        ? 'border-indigo-500 transform lg:scale-110 lg:-translate-y-2 relative z-10 shadow-xl shadow-indigo-500/20'
                        : 'border-gray-700/50 hover:border-gray-500/50 hover:-translate-y-2 hover:shadow-lg hover:shadow-indigo-500/10'
                    )}
                  >
                    {plan.recommended && (
                      <div className="bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] text-white text-center py-2 font-medium">
                        MOST POPULAR
                      </div>
                    )}
                    <div className="p-6 md:p-8 flex flex-col flex-grow">
                      <h3 className="text-xl md:text-2xl font-bold mb-4 group-hover:text-[var(--primary)] transition-colors duration-300">
                        {plan.name}
                      </h3>
                      <div className="flex items-baseline mb-6">
                        <span className="text-4xl md:text-5xl font-extrabold">
                          ${plan.price}
                        </span>
                        <span className="text-gray-400 ml-2">/month</span>
                      </div>
                      <ul className="space-y-4 mb-8 flex-grow">
                        {plan.features.map((feature, i) => (
                          <li key={i} className="flex items-start">
                            <div className="mr-3 rounded-full p-1 bg-indigo-500/10 text-indigo-400 mt-0.5">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                            <span className="text-gray-300 group-hover:text-white transition-colors duration-300">
                              {feature}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <button
                        className={classNames(
                          'w-full py-3 px-6 rounded-full font-medium transition-all duration-500',
                          plan.recommended
                            ? 'bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] hover:shadow-lg hover:shadow-indigo-500/30 text-white transform hover:scale-105'
                            : 'bg-gray-700 hover:bg-gradient-to-r hover:from-[var(--primary)] hover:to-[var(--secondary)] text-white transform hover:scale-105'
                        )}
                      >
                        {plan.ctaText}
                      </button>
                    </div>
                    {/* Animated corner effect for the recommended plan */}
                    {plan.recommended && (
                      <div className="absolute -top-10 -right-10 w-20 h-20 bg-gradient-to-br from-[var(--primary)] to-[var(--secondary)] rotate-45 opacity-20"></div>
                    )}
                  </div>
                </Animate>
              ))}
            </div>
          </Animate>
        </div>
      </section>
      {/* CTA Section */}
      <section
        id="get-started"
        className={classNames(styles.ctaSection, styles.section)}
      >
        <div className={styles.content}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <Animate animationName="slideLeft">
              <div className="text-left">
                <h2 className="text-3xl md:text-5xl font-bold mb-6 gradient-text">
                  Ready to transform your gym business?
                </h2>
                <p className="text-xl text-gray-300 mb-8">
                  Join thousands of successful gym owners who have transformed
                  their operations and enhanced their member experience with
                  JimGym.
                </p>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 h-8 w-8 rounded-full bg-indigo-500/10 flex items-center justify-center mt-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-indigo-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-white">
                        No credit card required
                      </h3>
                      <p className="text-gray-400">
                        Start your 14-day free trial without any commitment
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 h-8 w-8 rounded-full bg-indigo-500/10 flex items-center justify-center mt-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-indigo-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-white">
                        Easy setup process
                      </h3>
                      <p className="text-gray-400">
                        Get your gym management system running in minutes
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 h-8 w-8 rounded-full bg-indigo-500/10 flex items-center justify-center mt-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-indigo-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-white">
                        Dedicated support
                      </h3>
                      <p className="text-gray-400">
                        Get help from our team every step of the way
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-10 flex flex-col sm:flex-row gap-4">
                  <Link href="/auth/signup" passHref>
                    <button className="bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] text-white ml-2 px-8 py-4 rounded-full font-medium shadow-lg hover:shadow-indigo-500/30 transition-all text-lg hover:scale-105">
                      Start Your Free Trial
                    </button>
                  </Link>
                  <Link href="#contact-us" passHref>
                    <button className="bg-transparent border border-white/20 text-white px-8 py-4 rounded-full font-medium hover:bg-white/10 transition-all text-lg">
                      Contact Sales
                    </button>
                  </Link>
                </div>
              </div>
            </Animate>

            <Animate animationName="scaleIn" delay="200">
              <div className="relative hidden lg:block">
                <div className="absolute -inset-1 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] rounded-lg blur-lg opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse"></div>
                <div className="relative glass-effect p-8 rounded-xl overflow-hidden">
                  <div className="mockup-window">
                    <div className="p-4 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg">
                      <div className="flex items-center gap-3 mb-6">
                        <div className="w-3 h-3 rounded-full bg-red-400"></div>
                        <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                        <div className="w-3 h-3 rounded-full bg-green-400"></div>
                        <div className="ml-4 h-6 w-32 bg-gray-700 rounded-md"></div>
                      </div>

                      <div className="grid grid-cols-3 gap-4 mb-4">
                        <div className="h-12 bg-gray-700 rounded animate-pulse"></div>
                        <div className="h-12 bg-gray-700 rounded animate-pulse"></div>
                        <div className="h-12 bg-gray-700 rounded animate-pulse"></div>
                      </div>

                      <div className="h-32 mb-4 rounded bg-gradient-to-r from-indigo-500/30 to-violet-500/30 animate-pulse"></div>

                      <div className="space-y-3">
                        <div className="h-4 w-3/4 bg-gray-700 rounded animate-pulse"></div>
                        <div className="h-4 bg-gray-700 rounded animate-pulse"></div>
                        <div className="h-4 w-5/6 bg-gray-700 rounded animate-pulse"></div>
                      </div>
                    </div>
                  </div>

                  <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-gradient-to-br from-[var(--primary)] to-[var(--secondary)] rounded-full opacity-20 blur-xl animate-pulse"></div>
                </div>
              </div>
            </Animate>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section
        id="contact-us"
        className={classNames(
          styles.contactUs,
          styles.section,
          'min-h-screen flex items-center py-12'
        )}
      >
        <div className={styles.content}>
          <Animate animationName="slideDown">
            <h1 className={styles.contactUsTitle}>Contact Us</h1>
            <p className={styles.contactUsDescription}>
              Have questions? Our team is here to help you find the perfect
              solution for your gym.
            </p>
          </Animate>
          <ContactSection />
        </div>
      </section>
      {/* Footer Section */}
      <footer className={classNames(styles.footer, styles.section)}>
        <div className={styles.content}>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            {/* Logo and description column */}
            <div className="md:col-span-5 space-y-4">
              <div className="text-2xl font-bold gradient-text inline-block">
                JimGym
              </div>
              <p className="text-gray-400 mt-4 pr-4 leading-relaxed">
                The complete gym management solution that empowers gym owners,
                trainers, and members to achieve their fitness business goals
                with powerful, easy-to-use technology.
              </p>
              <div className={styles.socialLinks}>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label="Facebook"
                >
                  <div className={styles.socialIconWrapper}>
                    <FacebookIcon />
                  </div>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label="Instagram"
                >
                  <div className={styles.socialIconWrapper}>
                    <InstagramIcon />
                  </div>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label="Twitter"
                >
                  <div className={styles.socialIconWrapper}>
                    <TwitterIcon />
                  </div>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label="LinkedIn"
                >
                  <div className={styles.socialIconWrapper}>
                    <LinkedInIcon />
                  </div>
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label="YouTube"
                >
                  <div className={styles.socialIconWrapper}>
                    <YoutubeIcon />
                  </div>
                </a>
              </div>
            </div>

            {/* Navigation links columns */}
            <div className="md:col-span-7">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                {/* Product column */}
                <div>
                  <h3 className={styles.footerHeading}>Product</h3>
                  <ul className="space-y-3">
                    <li>
                      <a href="#features" className={styles.footerLink}>
                        Features
                      </a>
                    </li>
                    <li>
                      <a href="#pricing" className={styles.footerLink}>
                        Pricing
                      </a>
                    </li>
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        API
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        Integrations
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Resources column */}
                <div>
                  <h3 className={styles.footerHeading}>Resources</h3>
                  <ul className="space-y-3">
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        Documentation
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        Blog
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                    <li>
                      <a href="#contact-us" className={styles.footerLink}>
                        Support
                      </a>
                    </li>
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        Community
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Company column */}
                <div>
                  <h3 className={styles.footerHeading}>Company</h3>
                  <ul className="space-y-3">
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        About Us
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        Careers
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                    <li>
                      <a href="#contact-us" className={styles.footerLink}>
                        Contact
                      </a>
                    </li>
                    <li>
                      <span className={styles.footerLinkDisabled}>
                        Privacy Policy
                        <span className={styles.comingSoonBadge}>Soon</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright section */}
          <div className={styles.footerBottom}>
            <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-800">
              <p className="text-gray-500 text-sm">
                &copy; {new Date().getFullYear()} JimGym. All rights reserved.
              </p>
              <div className="mt-4 md:mt-0 flex space-x-4 text-sm">
                <span className={styles.footerLinkSmall}>Terms of Service</span>
                <span className={styles.footerLinkSmall}>Privacy Policy</span>
                <span className={styles.footerLinkSmall}>Cookies</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <ScrollToTop scrollableDivRef={scrollableDivRef} />
    </div>)
  );
}
